angular.module('app.filters').filter('trustHtml', ($sce) => (html) => $sce.trustAsHtml(html));
